exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clickable-tile[data-v-5345ef90] {\n  width: 100%;\n  padding: 20px;\n  background-color: #ffffff;\n  color: #c1006d;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  cursor: pointer;\n  box-shadow: 3px 1px 5px #ccc;\n}\n.clickable-tile .icon[data-v-5345ef90] {\n  font-size: 5em;\n  color: #230a62;\n}\n.clickable-tile .text[data-v-5345ef90] {\n  margin-top: 15px;\n}\n.clickable-tile[data-v-5345ef90]:hover {\n  background-color: #f9f9f9;\n}\n", ""]);

// exports
